import { serviceHost } from '../../common/const';
import ServiceRequest from '../../utils/service-request';

export const getAuditLogs = async (clientId) => {
    try {
        let response = await ServiceRequest('get', 'multipart/form-data', serviceHost + '/auditlogs/' + clientId);
        return { response, err: null };
    }
    catch (err) {
        if (err) {
            return { response: null, err };
        }
    };
}